export default __webpack_public_path__ + "static/media/share-30.a1992c35.svg";